
export const validationMessages = {
  undefined: () => `Something went wrong.`,
  required: (label) => `${label} is required.`,
  invalidUrlOrId: () => `This Youtube URL or ID is invalid.`,
  maxVideoLength: () => `This video is too long.`,
  noCaptions: () => `Closed captions are required for this video.`,
  noEmbedding: () => `Video embedding is restricted. Ensure the video allows embedding or provide a different video.`,
};
